import { createSlice } from "@reduxjs/toolkit";

const addFlightShop = {
  searchDestination: {
    flyFrom: "",
    flyTo: "",
  },
};
const formDatas = [];
const formOptions = {
  yourAirline: [],
  brands: [],
  ota: [],
  meta: [],
  gds: [],
  rateparity: "",
};

const customDays = [];
const monthlyDays = [];
const horizonDays = [];
const form2Details = {};
const form1Details = {};
const volatalityDetails = {}
const form3Details = {};
const deliveryTimes = [];
const flightShopSettings = {};
const searchFlightShopResult = {};
const priceEvolutionMonthlyDays = [];
const priceEvolutionDeliveryTimes = [];

const AddFlightShopSlice = createSlice({
  name: "addFlightShop",
  initialState: {
    formDatas,
    customDays,
    horizonDays,
    monthlyDays,
    formOptions,
    form1Details,
    form2Details,
    form3Details,
    deliveryTimes,
    addFlightShop,
    volatalityDetails,
    flightShopSettings,
    searchFlightShopResult,
    priceEvolutionMonthlyDays,
    priceEvolutionDeliveryTimes,
  },
  reducers: {
    setFlyFromAndTo(state, action) {
      state.addFlightShop.searchDestination = action.payload;
    },
    setFormOptions(state, action) {
      state.formOptions = { ...formOptions, ...action.payload };
    },
    setForm1Details(state, action) {
      state.form1Details = { ...form1Details, ...action.payload };
    },
    setForm2Details(state, action) {
      state.form2Details = { ...form2Details, ...action.payload };
    },
    setForm3Details(state, action) {
      state.form3Details = { ...form2Details, ...action.payload };
    },
    setFlightShopSettings(state, action) {
      state.flightShopSettings = { ...flightShopSettings, ...action.payload };
    },
    setMonthlyDays(state, action) {
      state.monthlyDays = action.payload;
    },
    setHorizonDays(state, action) {
      state.horizonDays = action.payload;
    },
    setCustomDays(state, action) {
      state.customDays = action.payload;
    },
    setPriceEvolutionMonthlyDays(state, action) {
      state.priceEvolutionMonthlyDays = action.payload;
    },
    setDeliveryTimes(state, action) {
      state.deliveryTimes = action.payload;
    },
    setPriceEvolutionDeliveryTimes(state, action) {
      state.priceEvolutionDeliveryTimes = action.payload;
    },
    resetAllFormDetails(state) {
      state.form1Details = {};
      state.form2Details = {};
      state.form3Details = {};
      state.form3Details = {};
      state.addFlightShop.searchDestination = {};
      state.customDays = []
      state.horizonDays = []
      state.monthlyDays = []
      state.deliveryTimes = []
      state.priceEvolutionMonthlyDays = []
      state.priceEvolutionDeliveryTimes = []
    },
    setFormDatas(state, action) {
      state.formDatas = action.payload;
    },
    setVolatalityDetails(state, action) {
      state.volatalityDetails = action.payload;
    },
    setSearchFlightShopResult(state, action) {
      state.searchFlightShopResult = action.payload;
    },
  },
});

export const {
  setFormDatas,
  setCustomDays,
  setFormOptions,
  setMonthlyDays,
  setHorizonDays,
  setForm1Details,
  setForm2Details,
  setForm3Details,
  setFlyFromAndTo,
  setDeliveryTimes,
  resetAllFormDetails,
  setVolatalityDetails,
  setFlightShopSettings,
  setSearchFlightShopResult,
  setPriceEvolutionMonthlyDays,
  setPriceEvolutionDeliveryTimes
} = AddFlightShopSlice.actions;

export default AddFlightShopSlice.reducer;
